import { useCallback, useState } from 'react'

/**
 * Etapas de dados que o cliente já conferiu nesta solicitação. Uma pessoa já
 * cadastrada chega preenchida, mas o cliente passa por todas as etapas de novo
 * para confirmar que os dados continuam valendo.
 */
const storageKey = (applicationKey: string) =>
  `credit-confirmed:${applicationKey}`

export function readConfirmedSteps(applicationKey: string): string[] {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(storageKey(applicationKey)) ?? '[]',
    ) as unknown
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : []
  } catch {
    return []
  }
}

export function clearConfirmedSteps(applicationKey: string) {
  try {
    localStorage.removeItem(storageKey(applicationKey))
  } catch {
    // sem armazenamento o cliente só confirma as etapas de novo
  }
}

export function useConfirmedSteps(applicationKey: string) {
  const [confirmed, setConfirmed] = useState(() =>
    readConfirmedSteps(applicationKey),
  )

  const confirm = useCallback(
    (step: string) => {
      setConfirmed((current) => {
        if (current.includes(step)) return current
        const next = [...current, step]
        try {
          localStorage.setItem(storageKey(applicationKey), JSON.stringify(next))
        } catch {
          // a confirmação vale ao menos até a página ser recarregada
        }
        return next
      })
    },
    [applicationKey],
  )

  return { confirmed, confirm }
}
